import styled from 'styled-components';

export const ExpanderWrapper = styled.div`
  position: relative;
`;

export const ChildrenContainer = styled.div<{ height: number }>`
  height: ${p => p.height}px;
  overflow: hidden;
  transition: all 0.2s cubic-bezier(0.15, 0.9, 0.5, 1.1);
`;

export const ToggleButtonWrapper = styled.div<{ isExpanded: boolean }>`
  display: flex;
  width: 100%;
  justify-content: center;
  svg {
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'none')};
    transition: transform 0.4s cubic-bezier(0, 1.15, 0.3, 1.25);
  }
`;
